import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import ServiceFlowTemplateWorkspace from '@/components/Events/ServiceFlow/ServiceFlowTemplateWorkspace';

/** Template workspace for an existing Service Flow template (spec §3.4). */
const ServiceFlowTemplateScreen = () => {
    const { templateID } = useLocalSearchParams();
    return <ServiceFlowTemplateWorkspace templateID={templateID || null} />;
};

export default ServiceFlowTemplateScreen;
